import { createApi, createDomain } from 'effector';

const domain = createDomain('hotspot');

export type PlayerWidgetType =
  | 'sysIcon'
  | 'title'
  | 'icon'
  | 'batchPreview'
  | 'mark';

export const $playerWidgets = domain.store<PlayerWidgetType[]>([]);
export const $playerWidgetsApi = createApi($playerWidgets, {
  add: (state, payloed: PlayerWidgetType) => {
    return state.includes(payloed)
      ? state.filter((x) => x !== payloed)
      : [...state, payloed];
  },
  remove: (state, payloed: PlayerWidgetType) => {
    return state.filter((x) => x !== payloed);
  },
  clear: () => [],
});
